export default {
  search: {
    title: 'Candidate Search',
    tab: 'CANDIDATE SEARCH'
  },
  pool: {
    title: 'Talent Pool',
    tab: 'TALENT POOL',
    potential: 'Talent Pool - Potential'
  },
  title: {
    add: 'Create New Talent Pool',
    edit: 'Edit Talent Pool',
    tip: 'Warning'
  },
  label: {
    groupName: 'Talent Pool Name',
    groupVisibility: 'Visibility',
    parentGroup: 'Parent Talent Pool',
    parentGroupTip: '(if have)',
    groupFilterDetail: 'Detail',
    total: 'Total',
    authOwner: 'Access',
    role: 'Role',
    recruiter: 'Recruiter',
    roleAccess: 'Role Access',
    recruiterAccess: 'Recruiter Access',
    noData: 'No data',
    access: 'Access',
    groupAssign: 'Access: ',
    private: 'Private'
  },
  GROUP_VISIBILITY: {
    PUBLIC: 'Public',
    PRIVATE: 'Private'
  },
  message: {
    assignSuccess: 'Successfully assigned.',
    assignFailed: 'Error occurs, please retry to assign.'
  }
}
